import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import '../../../assets/js/admin.js';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-layout-inicial',
  templateUrl: './layout-inicial.component.html',
  styleUrls: ['./layout-inicial.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LayoutInicialComponent implements OnInit {
  imageLogo = "assets/images/logo_sisprev_web.png";

  onImageError(event: any) {
    this.imageLogo = 'assets/images/LogoPortal.png';  // Caminho da imagem de fallback
  }

  constructor(private router: Router) { }

  ngOnInit() {
  }
  logout() {
    localStorage.removeItem('AcessoAdm');
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/layout-inicial/layout-inicial.component.ts